import { unifiedApiKeys } from '@/services/keys';

import type { UnifiedApiParams } from '@/types/mercury-data-types/unifiedapi';

export const threatActorKeys = {
  table: (params?: Partial<UnifiedApiParams>) =>
    ['table', ...unifiedApiKeys.records('/catalog/threat_actors', params)] as const,

  gfx: (context: string, params?: Partial<UnifiedApiParams>) =>
    ['threat_actors', 'gfx', ...unifiedApiKeys.records(context, params)] as const,
};
